const isProduction = process.env.REACT_APP_PRODUCTION_MODE == "true";
const isOnServer = process.env.REACT_APP_ON_SERVER == "true";
const port = process.env.REACT_APP_SERVER_PORT;

const local_url = "http://localhost";
const test_url = "https://test.ecaretherapy.com";
const production_url = "https://ecaretherapy.com";
const local_server_url = local_url + ":" + port;
const production_server_url = production_url + "/api";
const testing_server_url = test_url + "/api";

// const local_server_url = "http://localhost:" + port;

let main_url = local_server_url;
let image_url = testing_server_url;
let socket_connect_url = local_url;
if (isOnServer) {
  if (isProduction) {
    main_url = production_server_url;
    image_url = production_server_url;
    socket_connect_url = production_url;
  } else {
    main_url = testing_server_url;
    image_url = testing_server_url;
    socket_connect_url = test_url;
  }
}

const ConstConfig = {
  LOCAL_URL: local_url,
  TESTING_URL: test_url,
  PRODUCTION_URL: production_url,
  SOCKET_CONNECTION_URL: socket_connect_url,
  MAIN_URL: main_url,
  IMAGE_URL: image_url,
  SERVER_ERR_MSG: "Somthing went wrong. Please try again later.",
  ROOT_PATH: "/",
};

export default ConstConfig;
